import React, { ReactNode } from 'react'
import { IonIcon, IonSkeletonText } from '@ionic/react'
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons'
import { formatValue } from '../utils/formatValueWithPrecision'
import { nextPeriod, prettyFormatTimePeriod, previousPeriod, TimePeriod } from '../../../utils/timePeriod'

export interface ChartScrollerProps {
    timePeriod: TimePeriod
    setTimePeriod: (tp: TimePeriod) => void
    tooltipLoading: boolean
    value: number
    unit: string
    canGoNext?: boolean
    canGoPrevious?: boolean
    children?: ReactNode
}

const ChartScroller: React.FC<ChartScrollerProps> = ({
    timePeriod,
    setTimePeriod,
    tooltipLoading,
    value,
    unit,
    canGoNext = false,
    canGoPrevious = false,
    children,
}) => {

    return (
        <div
            id='electricity-content-scroller'
            className='flex w-full flex-row justify-between bg-white dark:bg-background-200-dark text-text-grey-200 dark:text-text-grey-100 shadow-card'
        >
            <div className='up flex flex-col'>
                <div className='left'>
                    <div className='time-string'>{prettyFormatTimePeriod(timePeriod)}</div>
                    <div className='row'>
                        {tooltipLoading ? (
                            <>
                                <IonSkeletonText
                                    animated={true}
                                    style={{ width: '25%', minHeight: '1rem', top: '0.2rem', margin: 0 }}
                                />
                                <span className='main w-[1px] text-white dark:text-background-200-dark'>|</span>
                            </>
                        ) : (
                            <span className='main text-brand-primary-100-light dark:text-brand-primary-100-dark'>
                                {isNaN(value) ? '0,0' : formatValue(value, 'consumption', { forceDecimals: 2 })}
                            </span>
                        )}
                        <span className='unit consumption text-text-dark dark:text-white'>{unit}</span>
                    </div>
                </div>
                <div className='info text-text-dark dark:text-white'>{children}</div>
            </div>
            <div className='right flex items-center justify-center'>
                <div className='chevrons'>
                    {canGoPrevious ? (
                        <IonIcon
                            className='bg-brand-primary-200-light text-brand-secondary-100-light dark:text-brand-secondary-100-dark dark:bg-brand-secondary-200-dark button-hover'
                            onClick={() => setTimePeriod(previousPeriod(timePeriod))}
                            icon={chevronBackOutline}
                        />
                    ) : (
                        <IonIcon
                            className='disabled bg-brand-primary-200-light text-brand-secondary-100-light dark:text-brand-secondary-200-dark dark:bg-background-100-dark cursor-default'
                            icon={chevronBackOutline}
                        />
                    )}
                    {canGoNext ? (
                        <IonIcon
                            className='bg-brand-primary-200-light text-brand-secondary-100-light dark:text-brand-secondary-100-dark dark:bg-brand-secondary-200-dark button-hover'
                            onClick={() => setTimePeriod(nextPeriod(timePeriod))}
                            icon={chevronForwardOutline}
                        />
                    ) : (
                        <IonIcon
                            className='disabled bg-brand-primary-200-light text-brand-secondary-100-light dark:text-brand-secondary-200-dark dark:bg-background-100-dark cursor-default'
                            icon={chevronForwardOutline}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default ChartScroller
